var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"11.5","fill":"white","stroke":"#F36633"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"12","cy":"12","r":"6","fill":"#F36633"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }